<template>
<span>
<b-row>

  <b-col cols="6">
    <label class="text-gray mb-1" style="font-size: 14px;">Country</label>
          <b-form-group>
          <b-form-select
            id="country"
            @change="selectCountry(countryId)"
            class="form-select  noFocus text-gray mb-2"
            v-model="countryId"
            :disabled="true"
            :options="countryList">
          </b-form-select>
          </b-form-group>
    </b-col>


<!--    <b-col cols="6">
      <label class="text-gray mb-1" style="font-size: 14px;">Region</label>
       <b-form-group>
          <b-form-select
            id="region"
            @change="selectRegion(regionId)"
            class="form-select  noFocus text-gray mb-2"
            v-model="regionId"
            :disabled="true"
            :options="regionList">
          </b-form-select>
          </b-form-group>
    </b-col>-->

   <b-col cols="6">
     <label class="text-gray mb-1" style="font-size: 14px;">District</label>
     <b-form-group>
       <b-form-select
         id="district"
         @change="selectDistrict(districtId)"
         class="form-select  noFocus text-gray mb-2"
         v-model="districtId"
         :disabled="true"
         :options="districtList">
       </b-form-select>
     </b-form-group>
  </b-col>

  <b-col cols="6">
    <label class="text-gray mb-1" style="font-size: 14px;">County</label>
    <b-form-group>
      <b-form-select
        id="county"
        @change="selectCounty(countyId)"
        class="form-select  noFocus text-gray mb-2"
        v-model="countyId"
        :disabled="true"
        :options="countyList">
      </b-form-select>
    </b-form-group>
  </b-col>


  <b-col cols="6">
    <label class="text-gray mb-1" style="font-size: 14px;">Sub County</label>
     <b-form-group>
       <b-form-select
         id="subCounty"
         @change="selectSubCounty(subCountyId)"
         class="form-select  noFocus text-gray mb-2"
         v-model="subCountyId"
         :disabled="true"
         :options="subCountyList">
       </b-form-select>
     </b-form-group>
  </b-col>

  <b-col cols="6">
    <label class="text-gray mb-1" style="font-size: 14px;">Parish</label>
      <b-form-group>
        <b-form-select
          id="parish"
          @change="selectParishData(parishId)"
          class="form-select  noFocus text-gray mb-2"
          v-model="parishId"
          :disabled="true"
          :options="parishList">
        </b-form-select>
      </b-form-group>
  </b-col>


  <b-col cols="6">
     <label class="text-gray mb-1" style="font-size: 14px;">Village</label>
      <b-form-group>
        <b-form-select
          id="village"
          @change="selectVillage(villageId)"
          class="form-select  noFocus text-gray"
          v-model="villageId"
          :disabled="true"
          :options="villageList">
        </b-form-select>
      </b-form-group>
  </b-col>
</b-row>



</span>
</template>

<script>
import {mapActions} from "vuex";
import {api} from "@/app/services/api.service";

export default {
  name: "AdminUnits",
  props:{
    index:Number,
    villageDataInfo:{}
  },
  data(){
    return{
      countryList:[],
      countryId:"",
      regionList:[],
      regionId:"",
      districtId:"",
      districtList:[],
      countyId:"",
      countyList:[],
      subCountyId:"",
      subCountyList:[],
      parishId:"",
      parishList:[],
      villageId:"",
      villageList:[],
    }
  },
  mounted() {
    this.fetchCountriesAsync();
    this.checkAdminUnitInfo()
  },
  methods:{
    ...mapActions(
      [
        "fetchRegion",
        "fetchCountries",
        "fetchDistricts",
        "fetchCounty",
        "fetchSubCounty",
        "fetchParish",
        "fetchVillage"
      ]
    ),
    async fetchCountriesAsync() {
      await api().get("configuration/address/country")
        .then((response) => {
          let arr = [{value: "", text: "--Select Country--"}]
          this.countryList = arr.concat(this.filterUnitData(response.data))

        })
        .catch((error) => {
          this.$store.commit("setDistrictsResultsError", error.response);
        });
    },
    async fetchRegionAsync(countryId) {
      await api().get("configuration/address/region?countryId=" + countryId)
        .then((response) => {
          let arr = [{value: "", text: "--Select Region--"}]
          this.regionList = arr.concat(this.filterUnitData(response.data))

        })
        .catch((error) => {
          this.$store.commit("setDistrictsResultsError", error.response);
        });
    },
    async fetchDistrictAsync(regionId) {
      await api().get("configuration/address/district?regionId=" + regionId)
        .then((response) => {
          let arr = [{value:"", text: "--Select District--"}]
          this.districtList = arr.concat(this.filterUnitData(response.data))
        })
        .catch((error) => {
          this.$store.commit("setDistrictsResultsError", error.response);
        });
    },
    async fetchCountyAsync(districtId) {
      await api().get("configuration/address/county?districtId=" + districtId)
        .then((response) => {
          let arr = [{value:"", text: "--Select County--"}]
          this.countyList = arr.concat(this.filterUnitData(response.data))
        })
        .catch((error) => {
          this.$store.commit("setDistrictsResultsError", error.response);
        });
    },
    async fetchSubCountyAsync(districtId) {
      await api().get("configuration/address/sub-county?districtId=" + districtId)
        .then((response) => {
          let arr = [{value:"", text: "--Select Sub County--"}]
          this.subCountyList = arr.concat(this.filterUnitData(response.data))
        })
        .catch((error) => {
          this.$store.commit("setDistrictsResultsError", error.response);
        });
    },
    async fetchVillageAsync(parishId) {
      await api().get("configuration/address/village?parishId=" + parishId)
        .then((response) => {
          let arr = [{value:"", text: "--Select Village--"}]
          this.villageList = arr.concat(this.filterUnitData(response.data))
        })
        .catch((error) => {
          this.$store.commit("setDistrictsResultsError", error.response);
        });
    },
    async fetchParishAsync(subCountyId) {
      await api().get("configuration/address/parish?subCountyId=" + subCountyId)
        .then((response) => {
          let arr = [{value: "", text: "--Select Parish--"}]
          this.parishList = arr.concat(this.filterUnitData(response.data))
        })
        .catch((error) => {
          this.$store.commit("setDistrictsResultsError", error.response);
        });
    },
    async selectCountry(countryId){
      if(countryId) {
        await this.fetchRegionAsync(countryId);
      }
    },
    async selectRegion(regionId){
      await  this.fetchDistrictAsync(regionId)
    },
    async selectDistrict(districtId){
      await this.fetchCountyAsync(districtId)
      await this.fetchSubCountyAsync(districtId)
    },
    async selectCounty(countyId){
      this.$emit("selectedCounty", countyId)
    },
    async selectParishData(parishId){
      await this.fetchVillageAsync(parishId)
    },
    selectVillage(village){
      this.$emit("selectedVillage",village);
    },
    async selectSubCounty(subCountyId){
      await this.fetchParishAsync(subCountyId)
    },
    ensureOptionInList(list, id, name) {
      if (!id) return list;
      const exists = list.some(item => String(item.value) === String(id));
      if (!exists) {
        return [...list, { value: id, text: name || id }];
      }
      return list;
    },
    async checkAdminUnitInfo(){
      if(this.villageDataInfo && Object.keys(this.villageDataInfo).length > 0) {
        let data = this.villageDataInfo

        if (data.country && data.country.id) {
          this.countryId = data.country.id
          this.countryList = this.ensureOptionInList(this.countryList, data.country.id, data.country.name)
          await this.selectCountry(data.country.id)
        } else {
          this.countryId = ""
        }

        if (data.region && data.region.id) {
          this.regionId = data.region.id
          this.regionList = this.ensureOptionInList(this.regionList, data.region.id, data.region.name)
          await this.selectRegion(data.region.id)
        } else {
          this.regionId = ""
        }

        if (data.district && data.district.id) {
          this.districtId = data.district.id
          this.districtList = this.ensureOptionInList(this.districtList, data.district.id, data.district.name)
          await this.selectDistrict(data.district.id)
        } else {
          this.districtId = ""
        }

        let countyNo = ""
        let countyName = ""
        if (data.county && data.county.id) {
          countyNo = data.county.id
          countyName = data.county.name
        }
        this.countyId = countyNo
        if (countyNo) {
          this.countyList = this.ensureOptionInList(this.countyList, countyNo, countyName)
          await this.selectCounty(countyNo)
        } else {
          this.countyId = ""
        }

        let subCountyNo = ""
        let subCountyName = ""
        if (data.subcounty && data.subcounty.id) {
          subCountyNo = data.subcounty.id
          subCountyName = data.subcounty.name
        } else if (data.subCounty && data.subCounty.id) {
          subCountyNo = data.subCounty.id
          subCountyName = data.subCounty.name
        }
        this.subCountyId = subCountyNo
        if (subCountyNo) {
          this.subCountyList = this.ensureOptionInList(this.subCountyList, subCountyNo, subCountyName)
          await this.selectSubCounty(subCountyNo)
        } else {
          this.subCountyId = ""
        }

        if (data.parish && data.parish.id) {
          this.parishId = data.parish.id
          this.parishList = this.ensureOptionInList(this.parishList, data.parish.id, data.parish.name)
          await this.selectParishData(data.parish.id)
        } else {
          this.parishId = ""
        }

        if (data.village && data.village.id) {
          this.villageId = data.village.id
          this.villageList = this.ensureOptionInList(this.villageList, data.village.id, data.village.name)
        } else {
          this.villageId = ""
        }
      }
    }

  },
  watch:{
    villageDataInfo:{
      async handler(){
        await this.checkAdminUnitInfo()
      },
      immediate: true,
      deep: true
    }
  }


}
</script>

<style scoped>

</style>